module.exports = __webpack_public_path__ + "img/logo.png.b8c86df2.webp";